import type { VersionResult, VerificationState } from '../../data/versions'
import { Card } from '../../ui/Card'

const states: VerificationState[] = ['verified', 'drift', 'unreleased', 'not_certified', 'unknown']
function ageText(seconds: number | null) {
  if (seconds === null || !Number.isFinite(seconds)) return 'Manifest age unavailable'
  const count = (n: number, unit: string) => `${n} ${unit}${n === 1 ? '' : 's'}`
  if (seconds < 60) return `Manifest age: ${count(Math.floor(seconds), 'second')}`
  if (seconds < 3600) return `Manifest age: ${count(Math.floor(seconds / 60), 'minute')}`
  return `Manifest age: ${count(Math.floor(seconds / 3600), 'hour')}`
}
export function VersionSummary({ components, manifestAgeSeconds }: { components: VersionResult[]; manifestAgeSeconds: number | null }) {
  return <Card title="Verification posture" className="version-summary"><div className="stat-grid">{states.map((state) => <div className="stat" key={state}><span className="stat-label">{state}</span><strong className="stat-value">{components.filter((item) => item.verification_state === state).length}</strong></div>)}</div><p className="field-help" aria-label="Manifest age">{ageText(manifestAgeSeconds)}</p></Card>
}
